import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { toast } from 'react-toastify';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import ModalDrawerSwitcher from '../../../../components/ModalDrawerSwitcher';
import Loader from '../../../../components/Loader';
import SingleDatePicker from '../../../../components/SingleDatePicker';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import Button from 'components/Button';
import ExportPDF from '../../../../components/ExportPDF';

import { onSelectChange, onTextChange } from '../../../../helpers/listeners';
import { textChange, handleBuildResume, clearBuildResumeFilters } from '../../store/actions';
import { loadAllEstablishmentsFinancialAndUsageResume, loadFinancialResume, loadUsageResume } from '../../store/thunk';

import { emailRegExp } from 'helpers/regex';
import { resumeTypes, months } from './sources';

import './styles.scss';

const IconResume = require('../../../../assets/img/icon-resume.svg');

class BuildResumeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.email,
      startDate: moment(moment.now()).format('YYYY-MM-DD'),
      endDate: moment(moment.now()).format('YYYY-MM-DD')
    }
  }

  getEmailHelperText() {
    if(!this.state.email) {
      return 'O email é obrigatório';
    }

    if(!emailRegExp.test(this.state.email)) {
      return 'O email precisa ser válido';
    }

    return '';
  }

  handleModal = () => {
    const { handleBuildResume, clearBuildResumeFilters } = this.props;

    handleBuildResume(false);
    clearBuildResumeFilters();
  }

  handleAllEstablishmentsResumeCreation = () => {
    const {
      loadAllEstablishmentsFinancialAndUsageResume,
      userId,
      startTime,
      endTime,
      resumeTypeId,
      allEstablishmentToastId
    } = this.props;

    const params = {
      description: +resumeTypeId == 1 ? `Resumo financeiro ${moment(this.state.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - ${moment(this.state.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}` : `Resumo de uso ${moment(this.state.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - ${moment(this.state.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}`,
      reportTypeId: resumeTypeId,
      email: this.state.email,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startTime: !!startTime ? `${startTime}:00` : '',
      endTime: !!endTime ? `${endTime}:00` : '',
      allEstablishmentToastId
    }

    return loadAllEstablishmentsFinancialAndUsageResume(userId, params);
  }

  handleResumeCreation = () => {
    const {
      loadFinancialResume,
      loadUsageResume,
      resumeMonthId,
      resumeTypeId,
      type,
      startTime,
      endTime,
      year,
      userId,
      establishmentId
    } = this.props;

    let { startDate, endDate } = this.state;

    if (type == 'month') {
      startDate = moment(`${year}-${resumeMonthId}`, 'YYYY-MM')
        .startOf('month')
        .format('YYYY-MM-DD');

      endDate = moment(`${year}-${resumeMonthId}`, 'YYYY-MM')
        .endOf('month')
        .format('YYYY-MM-DD');
    }

    return +resumeTypeId == 1
      ? loadFinancialResume(userId, establishmentId, startDate, endDate, startTime, endTime)
      : loadUsageResume(userId, establishmentId, startDate, endDate, startTime, endTime);
  }

  render() {
    const {
      isOpen,
      isLoading,
      establishmentId,
      type,
      startTime,
      endTime,
      resumeTypeId,
      resumeMonthId,
      fieldChange,
      year,
      option
    } = this.props;

    const isModal = option == 'modal';

    return (
      <ModalDrawerSwitcher
        id="accounts"
        title={type === 'day' ? 'Resumo diário' : 'Resumo mensal'}
        maxWidth="sm"
        open={isOpen}
        onClose={this.handleModal}
      >
        <Loader isLoading={isLoading}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <div>
              <Grid container>
                <Grid item xs={12}>
                  <Select
                    name="resumeTypeId"
                    label="Escolha o tipo do resumo"
                    options={resumeTypes}
                    value={resumeTypeId}
                    onChange={onSelectChange(fieldChange)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography color='primary'>
                    Ao gerar o resumo, aguarde o processo que poderá demorar alguns minutos.
                    O processo será iniciado em uma nova aba, desbloqueie 'pop-ups' em caso de bloqueio no seu navegador.
                  </Typography>
                </Grid>
              </Grid>
              {type == 'day' ? (
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} className="datapicker-range-container">
                    <Grid container>
                      <Grid xs={6} style={{ paddingRight: 2.5 }}>
                        <SingleDatePicker
                          noLabel
                          name="cashFlowDatePickerStartDate"
                          initialDate={this.state.startDate || null}
                          onDateChange={date => this.setState({ ...this.state, startDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') })}
                          blockFutureDates
                          onBlockedDate={() => toast.error('A data selecionada não pode ser maior do que a data atual.')}
                        />
                      </Grid>
                      <Grid xs={6} style={{ paddingLeft: 2.5 }}>
                        <SingleDatePicker
                          noLabel
                          name="cashFlowDatePickerEndDate"
                          initialDate={this.state.endDate || null}
                          onDateChange={date => this.setState({ ...this.state, endDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') })}
                          blockFutureDates
                          onBlockedDate={() => toast.error('A data selecionada não pode ser maior do que a data atual.')}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6} style={{ paddingRight: 2.5 }}>
                    <Input
                      id="startTime"
                      type="time"
                      label="Hora inicial"
                      placeholder="00:00"
                      value={startTime}
                      onChange={onTextChange(fieldChange)}
                    />
                  </Grid>
                  <Grid item xs={6} style={{ paddingLeft: 2.5 }}>
                    <Input
                      id="endTime"
                      type="time"
                      label="Hora final"
                      placeholder="00:00"
                      value={endTime}
                      onChange={onTextChange(fieldChange)}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Select
                      name="resumeMonthId"
                      label="Escolha o mês"
                      options={months}
                      value={resumeMonthId}
                      onChange={onSelectChange(fieldChange)}
                    />
                  </Grid>
                </Grid>
              )}
              {!establishmentId && (
                <Grid container>
                  <Grid item xs={12}>
                    <Input
                      id="email"
                      type="email"
                      label="E-mail"
                      value={this.state.email}
                      error={!this.state.email || !emailRegExp.test(this.state.email)}
                      helperText={this.getEmailHelperText()}
                      onChange={event => this.setState({ ...this.state, email: event.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography color='primary'>
                      Ao final do processo um email de confirmação será enviado. 
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </div>
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: isModal ? 'flex-end' : 'flex-start', marginTop: 10 }}>
                  {!establishmentId && (
                    <Button
                      fullWidth
                      loading={isLoading}
                      disabled={
                        !resumeTypeId ||
                        (type == 'month' && !resumeMonthId) ||
                        (type == 'day' && (!moment(this.state.startDate).isValid() || !moment(this.state.endDate).isValid())) ||
                        !this.state.email
                      }
                      color="success"
                      onClick={this.handleAllEstablishmentsResumeCreation}
                      startIcon={
                        <img
                          src={IconResume}
                          width={20}
                          height={20}
                        />
                      }
                    >
                      Gerar Resumo
                    </Button>
                  )}
                  {!!establishmentId && (
                    <ExportPDF
                      fullWidth
                      fileName={+resumeTypeId === 1 ? 'resumo_financeiro' : 'resumo_de_uso'}
                      color="success"
                      exportType={+resumeTypeId === 1 ? 'financialResume' : 'usageResume'}
                      loading={isLoading}
                      disabled={
                        !resumeTypeId ||
                        (type == 'month' && !resumeMonthId) ||
                        (type == 'day' && (!moment(this.state.startDate).isValid() || !moment(this.state.endDate).isValid()))
                      }
                      requestData={this.handleResumeCreation}
                      monthDate={
                        type === 'month'
                          ? {
                              startDate: moment(`${year}-${resumeMonthId}`)
                                .startOf('month')
                                .format('YYYY-MM-DD'),
                              endDate: moment(`${year}-${resumeMonthId}`)
                                .endOf('month')
                                .format('YYYY-MM-DD'),
                            }
                          : null
                      }
                      startIcon={
                        <img
                          src={IconResume}
                          width={20}
                          height={20}
                        />
                      }
                    >
                      Gerar Resumo
                    </ExportPDF>
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        </Loader>
      </ModalDrawerSwitcher>
    );
  }
}

BuildResumeModal.propTypes = {
  type: PropTypes.string.isRequired,
  handleBuildResume: PropTypes.func.isRequired,
  clearBuildResumeFilters: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  resumeTypeId: PropTypes.number.isRequired,
  resumeMonthId: PropTypes.number.isRequired,
  fieldChange: PropTypes.func.isRequired,
  loadAllEstablishmentsFinancialAndUsageResume: PropTypes.func.isRequired,
  loadFinancialResume: PropTypes.func.isRequired,
  loadUsageResume: PropTypes.func.isRequired,
  loadProfile: PropTypes.func.isRequired,
  year: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  ...state.cashFlow,
  page: state.pagination.activePage,
  pageSize: state.pagination.size,
  email: state.profile.submit.email,
  year: state.cashFlow.year,
  option: state.modalDrawerSwitcher.option
});

const mapDispatchToProps = {
  fieldChange: textChange,
  handleBuildResume,
  clearBuildResumeFilters,
  loadAllEstablishmentsFinancialAndUsageResume,
  loadFinancialResume,
  loadUsageResume
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildResumeModal);